import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import formattedData from 'utils/formattedData';

import type IDetailsRefusalModal from './interfaces/IDetailsRefusalModal';

import styles from './scss/DetailsRefusalModal.module.scss';

function DetailsRefusalModal({
  open,
  title,
  onClose,
  person,
  date,
  comment,
}: IDetailsRefusalModal) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title || t('common.detailsOfTheRefusal')}
      onClose={onClose}
      closeClassName={styles.close}
      isButtonsVisible={false}
    >
      <div className={styles.container}>
        {person ? (
          <div className={styles.field}>
            <div className={styles.label}>{t('common.person')}</div>
            <div className={styles.value}>{person}</div>
          </div>
        ) : null}

        {date ? (
          <div className={styles.field}>
            <div className={styles.label}>{t('common.date')}</div>
            <div className={styles.value}>{formattedData(date, true)}</div>
          </div>
        ) : null}

        {comment ? (
          <div className={styles.field}>
            <div className={styles.label}>{t('common.reason')}</div>
            <div className={styles.value}>{comment}</div>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}

export default DetailsRefusalModal;
